<template>
    <div class="step-container">
        <Header/>
        <div class="step">
            <b-container>
                <b-row>
                    <b-col lg="6" class="align-self-center">
                        <b-row class="progress-mobile mb-5 mt-4">
                            <ProgressBarMobile :percentage="20"/>
                        </b-row>
                        <b-row>
                            <b-col lg="12" class="mb-5">
                                <h3>COMENCEMOS TU APLICACIÓN</h3>
                                <p><strong>PASO 1.</strong> DATOS PERSONALES</p>
                            </b-col>
                            <b-form>
                                <b-row>
                                    <b-col lg="6">
                                        <b-form-group
                                            id="input-group-1"
                                            label="Nombre(s)*"
                                            label-for="input-1"
                                            class="mb-4"
                                        >
                                            <b-form-input
                                            id="input-1"
                                            v-model="name"
                                            placeholder="Ingresa tu nombre"
                                            type="text"
                                            :class="{'required': (btnActive && name=='')}"
                                            required
                                            ></b-form-input>
                                            <span class="required-label" :class="{'show': (btnActive && name=='')}">Favor de ingresar datos</span>
                                        </b-form-group>
                                    </b-col>

                                    <b-col lg="6">
                                        <b-form-group
                                            id="input-group-3"
                                            label="Apellido Paterno*"
                                            label-for="input-3"
                                            class="mb-4"
                                        >
                                            <b-form-input
                                            id="input-3"
                                            v-model="lastname1"
                                            type="text"
                                            placeholder="Ingresa tu apellido paterno"
                                            :class="{'required': (btnActive && lastname1=='')}"
                                            required
                                            ></b-form-input>
                                            <span class="required-label" :class="{'show': (btnActive && lastname1=='')}">Favor de ingresar datos</span>
                                        </b-form-group>
                                    </b-col>

                                    <b-col lg="6">
                                        <b-form-group id="input-group-2" label="Apellido Materno" label-for="input-2" class="mb-4">
                                            <b-form-input
                                            id="input-2"
                                            v-model="lastname2"
                                            placeholder="Ingresa tu apellido materno"
                                            required
                                            ></b-form-input>
                                        </b-form-group>
                                    </b-col>

                                    <b-col lg="6">
                                        <b-form-group id="input-group-4" label="Correo electrónico*" label-for="input-4" class="mb-4">
                                            <b-form-input
                                            id="input-4"
                                            v-model="email"
                                            type="email"
                                            placeholder="Ingresa tu correo electrónico"
                                            :class="{'required':  (btnActive && email=='')}"
                                            required
                                             @blur="validateEmail"
                                            ></b-form-input>
                                            <span class="required-label show"> {{msg}} <span v-show="(btnActive && email=='')">Favor de ingresar datos</span></span>
                                        </b-form-group>
                                    </b-col>

                                    <b-col lg="6">
                                        <b-form-group
                                            id="input-group-5"
                                            label="Fecha de nacimiento*"
                                            label-for="input-5"
                                            class="mb-4"
                                        >
                                            <date-picker 
                                                v-model="birthday" 
                                                format="DD/MM/YYYY"
                                                placeholder="DD / MM / AAAA"
                                                class="date-picker-input form-control"
                                                :lang="es"
                                                :class="{'disable': '' === birthday, 'required':  (btnActive && (birthday=='' || birthday==null))}">
                                            </date-picker>
                                            <span class="required-label" :class="{'show': (btnActive && birthday=='')}">Favor de ingresar datos</span>
                                            <span class="required-label" :class="{'show': (btnActive && !validateAge)}">Necesitas ser mayor de edad para solicitar tu crédito</span>
                                        </b-form-group>
                                    </b-col>
                                    <b-col lg="6">
                                        <b-form-group id="input-group-6" label="Estado Civil*" label-for="input-6" class="mb-4">
                                            <b-form-select
                                            id="input-6"
                                            v-model="civilStatus"
                                            :options="status"
                                            placeholder="Ingresa tu apellido materno"
                                            :class="{'disable': null === civilStatus, 'required':  (btnActive && civilStatus==null)}"
                                            required
                                            ></b-form-select>
                                            <span class="required-label" :class="{'show': (btnActive && civilStatus==null)}">Favor de ingresar datos</span>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-4">
                                    <b-col lg="6" cols="8">
                                        <b-button v-on:click.stop="nextStep" class="btn-next mb-4">Comenzar aplicación</b-button>
                                    </b-col>
                                    <b-col lg="6" cols="4">
                                        <img class="txt_min mb-4" src="../assets/img/txt_7min.svg" alt="icon"/>
                                    </b-col>
                                </b-row>
                            </b-form>
                        </b-row>
                        <b-row class="mt-3">
                            <div class="marquee-wrapper">
                                <div class="container">
                                    <div class="marquee-block">
                                        <div class="marquee-inner to-left">
                                            <span>
                                                <div v-for="i in 19" :key="i" class="marquee-item">
                                                    <img :src="require('../assets/img/icn_brand'+i+'_black.svg')"  alt="brand logo"/>
                                                </div>
                                            </span>
                                            <span>
                                                <div v-for="i in 19" :key="i" class="marquee-item">
                                                    <img :src="require('../assets/img/icn_brand'+i+'_black.svg')" alt="brand logo"/>
                                                </div>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </b-row>
                    </b-col>
                    <b-col lg="6" class="step-progress-bar">
                        <ProgressBar :percentage="20" :image="image" :image2="image2" />
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
    import ProgressBar from '../components/ProgressStep.vue'
    import ProgressBarMobile from '../components/ProgressStepMobile.vue'
    import Header from '../components/Header.vue'
    import axios from 'axios'
    import DatePicker from 'vue2-datepicker'    
    import es from 'vue2-datepicker/locale/es'
    import 'vue2-datepicker/index.css'
    
    export default {
        data() {
            return {
                image: require('./../assets/img/img_paso1.png'),
                image2: require('./../assets/img/img_paso1_tarjetas.png'),
                name: '',
                lastname1: '',
                lastname2: '',
                birthday: '',
                email: '',
                civilStatus: null,
                btnActive: false,
                validateAge: true,
                msg: '',
                status: [
                    { text: 'Selecciona una opcion', value: null, disabled: true }, { text: 'Soltero(a)*', value: 0 }, { text: 'Casado(a)*', value: 1 }],
            }
        },
        components: {
            ProgressBar,
            ProgressBarMobile,
            Header,
            DatePicker,
        },
        methods: {
            disabledDate (date) {
                return date.getTime() < Date.now()
            },
            getAge(dateString) {
                var today = new Date();
                var birthDate = new Date(dateString);
                var age = today.getFullYear() - birthDate.getFullYear();
                var m = today.getMonth() - birthDate.getMonth();
                if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) 
                {
                    age--;
                }
                return age;
            },
            formatDate(date) {
                var d = new Date(date),
                    month = '' + (d.getMonth() + 1),
                    day = '' + d.getDate(),
                    year = d.getFullYear();

                if (month.length < 2) 
                    month = '0' + month;
                if (day.length < 2) 
                    day = '0' + day;

                return [year, month, day].join('-');
            },
            validateEmail() {
                if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email)) {
                    this.msg = ''
                } else {
                    this.msg = 'Ingresa un correo válido. '
                }
            },
            nextStep() {
                let formData = new FormData()
                this.btnActive = true
                
                this.validateAge = parseInt(this.getAge(this.birthday))<18 ? false : true 
                if(this.name && this.lastname1 && this.birthday && this.email && this.civilStatus!=='' && this.msg=='' && this.validateAge ) {
                    formData.append('step', 1)
                    formData.append('applicant_name', this.name)
                    formData.append('applicant_first_lastname', this.lastname1)
                    formData.append('applicant_second_lastname', this.lastname2)
                    formData.append('applicant_birthday_full_date', this.formatDate(this.birthday))
                    formData.append('applicant_email', this.email)
                    sessionStorage.setItem('applicant_email', this.email)
                    formData.append('applicant_civil_state', this.civilStatus)
                    axios
                    .post(
                        'https://apply.garlans.com/private/helpers/application_submit_api.php',
                        formData,
                        {
                            headers: {
                                'Content-Type': 'multipart/form-data',
                            },
                        },
                    )
                    .then((response) => {
                        if (!response.data.status) {        
                            this.$router.push('/paso-2')
                        } else {
                            console.log(response)
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                    })
                }
            }
        }
    }
</script>

<style scoped>
.step-container{
    min-height: 100vh;
}
.step{
    padding: 3% 0;
    text-align: left;
    max-width: 100vw;
    overflow-x: hidden;
}
.progress-mobile{
    display: none;
}
h3{
    font-weight: bold;
}
p{
    font-weight: 500;
}
.txt_min{
    width: 50%;
}
label{
    margin-bottom: 10px;
}
.custom-select{
    display: block;
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #000;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(0, 0, 0, 0.3);
    border-radius: 0;
}
.disable.custom-select{
  color: rgba(0, 0, 0, 0.3) !important;
}
.custom-select:focus{
    color: #000;
    background-color: #fff;
    border-color: #000;
    outline: 0;
    -webkit-box-shadow: none;
    box-shadow: none;
}
.form-control {
    display: block;
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #000;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(0, 0, 0, 0.3);
    border-radius: 0;
}
.form-control::placeholder{
    color: rgba(0, 0, 0, 0.3);
}
.form-control:focus {
    color: #000;
    background-color: #fff;
    border-color: #000;
    outline: 0;
    -webkit-box-shadow: none;
    box-shadow: none;
}
.form-control:focus::placeholder{
    color: transparent;
}
.btn-next,
.btn-next:hover,
.btn-next:focus{
    outline: none !important;
    box-shadow: none;
    border-radius: 0;
    color: #fff;
    background: #000;
    width: 100%;
    text-align: center;
    font-weight: bold;
    transition: none !important;
}
.step-progress-bar{
    padding-left: 10%;
    padding-right: 5%;
}
.marquee-wrapper{
  text-align:center;
}
.marquee-wrapper .container{
  overflow:hidden;
}
.marquee-inner span{
  float:left;
  width:50%;
}
.marquee-wrapper .marquee-block{
  --total-marquee-items:19;
  height: 100px;
  width: calc(124px * (var(--total-marquee-items)));
  overflow: hidden;
  box-sizing: border-box;
  position: relative;
  margin: 20px auto;
  padding: 30px 0;
}
.marquee-inner{
  display: block;
  width: 200%;
  position: absolute;
}
.marquee-inner p{
  font-weight: 800;
  font-size: 30px;
  font-family: cursive;
}
.marquee-inner.to-left{
  animation: marqueeLeft 100s linear infinite;
}
.marquee-inner.to-right{
  animation: marqueeRight 40s linear infinite;
}
.marquee-item{
  width: fit-content;
  height: auto;
  display: inline-block;
  margin: 0 10px;
  float: left;
  transition: all .6s ease-out;
}
.marquee-item > img{
    height: 40px !important;
}
.required-label{
    color: #D85067;
    font-size: 10px;
    position: absolute;
    display: none;
}
.show.required-label{
    display: block;
}
@keyframes marqueeLeft{
    0% {
        left: 0;
    }
    100% {
        left: -100%;
    }
}
@keyframes marqueeRight{
    0% { 
        left: -100%; 
    }
    100% {
        left: 0; 
    }
}
@media (max-width: 768px) {
    .step{
        padding: 5%;
    }
    .txt_min{
        width: 100%;
    }
    .btn-next,
    .btn-next:hover,
    .btn-next:focus{
        font-size: 15px;
    }
    .step-progress-bar{
        display: none;
    }
    .form-control,
    .custom-select {
        padding: 0.75rem;
    }
    .progress-mobile{
        display: block;
    }
}
</style>